var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrap",class:[_vm.infoOutsideClass]},[_c('div',{staticClass:"progress",class:[_vm.stripedClass, _vm.animatedClass, _vm.sizeClass]},[_c('div',{staticClass:"progress-bar",class:[_vm.typeClass, _vm.sizeClass],style:({width: _vm.percent + '%'})},[(_vm.showinfo)?_c('span',{staticClass:"progress-info"},[_vm._v(_vm._s(_vm.info))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ddd95d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressbar/ProgressBar.vue
// module id = pY/W
// module chunks = 33